import * as Sentry from '@sentry/angular';
import { BrowserTracing } from '@sentry/tracing';
import { enableProdMode, ApplicationRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './modules/app.module';
import { environment } from './environments/environment';
import { env, version } from './environments/version';
import { enableDebugTools } from '@angular/platform-browser';

Sentry.init({
	dsn: 'https://14a0d043d15847218d3db6f7488b87b7@o4504604721020928.ingest.sentry.io/4504604733997056',
	release: `ovp-frontend@${version}`,
	environment: env,
	replaysSessionSampleRate: 0.1,
	// If the entire session is not sampled, use the below sample rate to sample
	// sessions when an error occurs.
	// replaysOnErrorSampleRate: 1.0,
	integrations: [
		new BrowserTracing({
			tracePropagationTargets: ['localhost', 'bbvms.com/ovp/', 'bbvms.com/sapi/'],
			routingInstrumentation: Sentry.routingInstrumentation,
		}),
		new Sentry.Replay(),
	],

	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for performance monitoring.
	// We recommend adjusting this value in production
	tracesSampleRate: 1.0,
	// Filter errors to only include those sent from URLs that include this in the filename present in the stacktrace
	allowUrls: [/https?:\/\/(.*\.)?bbvms\.com/]
});

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
	.then(moduleRef => {
		if (!environment.production) {
			const applicationRef = moduleRef.injector.get(ApplicationRef);
			const componentRef = applicationRef.components[0];
			enableDebugTools(componentRef);
		}
	})
	.catch(err => console.error(err));
